module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAADNQTFRFAAAA/4CA/052/1N4/013/1B1/1B2/091/092/1B2/1B2/092/091/1B2/092/092/092CR0gAAAAABF0Uk5TAAIaIitmfYWIjI2Rpbq8xNFTdGPcAAAAQElEQVQY02NgoDtgZ8YiyM1CtiAjTJARSZCPBSLIxookyMTPAhJk40LRDxTlZmHjRDOViZ+XhxPDciYBDvoHGADXpQEpm+H00AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/home_icon_arrow_drop.png
// module id = IXaa
// module chunks = 1